var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrows"
  }, /*#__PURE__*/React.createElement("g", {
    id: "minus-squared"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.3,
    d: "M8.16667 9.83317H4.83333C4.61232 9.83317 4.40036 9.74537 4.24408 9.58909C4.0878 9.43281 4 9.22085 4 8.99984C4 8.77882 4.0878 8.56686 4.24408 8.41058C4.40036 8.2543 4.61232 8.1665 4.83333 8.1665H8.16667V9.83317ZM13.1667 8.1665H9.83333V9.83317H13.1667C13.3877 9.83317 13.5996 9.74537 13.7559 9.58909C13.9122 9.43281 14 9.22085 14 8.99984C14 8.77882 13.9122 8.56686 13.7559 8.41058C13.5996 8.2543 13.3877 8.1665 13.1667 8.1665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.3,
    d: "M12.4915 0.666504H5.50817C2.83419 0.666504 0.666504 2.83419 0.666504 5.50817V12.4915C0.666504 15.1655 2.83419 17.3332 5.50817 17.3332H12.4915C15.1655 17.3332 17.3332 15.1655 17.3332 12.4915V5.50817C17.3332 2.83419 15.1655 0.666504 12.4915 0.666504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.1667 8.16667H9.83333V4.83333C9.83333 4.61232 9.74554 4.40036 9.58926 4.24408C9.43297 4.0878 9.22101 4 9 4C8.77899 4 8.56702 4.0878 8.41074 4.24408C8.25446 4.40036 8.16667 4.61232 8.16667 4.83333V8.16667H4.83333C4.61232 8.16667 4.40036 8.25446 4.24408 8.41074C4.0878 8.56702 4 8.77899 4 9C4 9.22101 4.0878 9.43297 4.24408 9.58926C4.40036 9.74554 4.61232 9.83333 4.83333 9.83333H8.16667V13.1667C8.16667 13.3877 8.25446 13.5996 8.41074 13.7559C8.56702 13.9122 8.77899 14 9 14C9.22101 14 9.43297 13.9122 9.58926 13.7559C9.74554 13.5996 9.83333 13.3877 9.83333 13.1667V9.83333H13.1667C13.3877 9.83333 13.5996 9.74554 13.7559 9.58926C13.9122 9.43297 14 9.22101 14 9C14 8.77899 13.9122 8.56702 13.7559 8.41074C13.5996 8.25446 13.3877 8.16667 13.1667 8.16667Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssign);
export default __webpack_public_path__ + "static/media/assign.763b4308006de7093c8b61fedf56d8c5.svg";
export { ForwardRef as ReactComponent };